var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { ref: "admin-navigationtop", staticClass: "shadow-sm app-header navbar" },
    [
      _c(
        "div",
        { staticClass: "h-100", attrs: { id: "qsLogo" } },
        [
          _c(
            "router-link",
            {
              staticClass: "pl-3 navbar-brand h-100",
              attrs: { to: { name: "admin/dashboard" } }
            },
            [
              _vm.agencyLogo
                ? _c("img", {
                    attrs: {
                      height: "66",
                      width: "200",
                      src: require("../../../assets/clients/" +
                        _vm.agencyLogo +
                        ".svg"),
                      id: "qrp-logo",
                      alt: "Rating Platform Logo"
                    }
                  })
                : _c("img", {
                    attrs: {
                      height: "66",
                      width: "200",
                      src: require("../../../assets/qrp-abbreviated-color.svg"),
                      alt: "QuinStreet Rating Platform"
                    }
                  })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "navbar-nav ml-auto header-nav" }, [
        _c(
          "li",
          { staticClass: "nav-item" },
          [
            _c(
              "router-link",
              { staticClass: "nav-link", attrs: { to: { name: "search" } } },
              [
                _c("i", { staticClass: "fas fa-search" }),
                _vm._v(" "),
                _c("div", { staticClass: "nav-label" }, [
                  _vm._v("Search Quote")
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item border-left" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              class: _vm.checkUserEditable(),
              attrs: { href: "JavaScript:void(0);", tabindex: "0" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toUserProfile()
                }
              }
            },
            [
              _c("span", {
                staticClass: "fas fa-user-circle",
                attrs: { title: "Dashboard" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "nav-label" }, [
                _vm._v(_vm._s(_vm.getUserName()))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "nav-item border-left" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.logout()
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-sign-out-alt" }),
              _vm._v(" "),
              _c("div", { staticClass: "nav-label" }, [_vm._v("Logout")])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2ebb192", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2ebb192","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/Navigationtop.vue
// module id = null
// module chunks = 